<template>
<textarea
    rows="3"
    v-model="model"
/>
</template>

<script>
export default {
    emits: ['input', 'update:modelValue'],
    name: 'TextAreaFieldForm',
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: String,
    },
    computed: {
        model: {
            get() { return this.modelValue; },
            set(value) { this.$emit('update:modelValue', value); },
        },
        inputCol() {
            return `col-12 col-md-${this.field.data.width} px-2`;
        },
    },
};
</script>
